module.exports = __webpack_public_path__ + "static/media/boxing-glove.3405377d.svg";